import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { WizardStatus } from '../../../../../../domain/wizard/wizard'

export type PerksClassDesignWizardState = {
  id: string
  name: string
  perksIds: number[]
  eligibleCategoryIds: number[]
  categoryAllowances: PerksProductClassExpenseCategoryAllowanceRequest[]
  waitingPeriod: number
  offerSameAllowance: boolean
  wizardStatues: WizardStatus
}

export type PerksProductClassExpenseCategoryAllowanceRequest = {
  expenseCategoryId: number
  amount?: number
  allowanceFrequency?: number
  startDate: string
  endDate: Date
  foreverPerk?: boolean
}

export const getPerksProductClassDesignWizardState = (productClassId: string): Promise<PerksClassDesignWizardState> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/ClassDesign/ClassDesignWizardState/${productClassId}`)
}
